import React from 'react';

import SVGIcon from '@palette/components/utils/Icons/SVGIcon/SVGIcon';

import ElectricalPlugFilledSvg from './svgs/ElectricalPlugFilled.svg';

const ElectricalPlugFilled = (props) => (<SVGIcon Component={ElectricalPlugFilledSvg} {...props} />);

export default ElectricalPlugFilled;
